import { basic, initSidebar, initTopbar } from './modules/layouts';
import { initLocaleDatetime, loadImg } from './modules/plugins';

basic();
initSidebar();
initTopbar();
initLocaleDatetime();
loadImg();
